import React, { useRef, useState } from 'react';

import ControlledTooltip from '~/components/ControlledTooltip';
import useScrollTranslation from '~/hooks/useScrollTranslation.ts';
import { cn } from '~/utils/cnTailwind';

type Props = {
    children: React.ReactNode;
    tooltipOffsetX?: number;
    tooltipOffsetY?: number;
    popoverClass?: string;
    tooltipText: string;
    tooltipClass?: string;
    wrapperClassName?: string;
};

export const HoverTooltip: React.FC<Props> = ({
    children,
    popoverClass,
    tooltipClass,
    tooltipOffsetX,
    tooltipOffsetY,
    tooltipText,
    wrapperClassName,
}) => {
    const ref = useRef<HTMLTableCellElement>(null);
    const { translationX, translationY } = useScrollTranslation(ref);

    const [iconTooltip, setIconTooltip] = useState(false);

    const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>, tooltipFn: (value: boolean) => void) => {
        const target = e.target as HTMLTableCellElement;
        if (document.activeElement !== target) {
            tooltipFn(true);
        }
    };

    return (
        <div
            className={wrapperClassName}
            onMouseLeave={() => setIconTooltip(false)}
            onMouseEnter={(e) => handleMouseEnter(e, setIconTooltip)}
        >
            {children}
            <ControlledTooltip
                translationX={translationX + (tooltipOffsetX ?? 0)}
                translationY={translationY + (tooltipOffsetY ?? 0)}
                open={iconTooltip}
                popoverClass={popoverClass}
            >
                <div
                    className={cn(
                        'whitespace-nowrap ml-2 px-3 py-1.5 rounded bg-blue text-white text-xs opacity-85',
                        tooltipClass,
                    )}
                >
                    {tooltipText}
                </div>
            </ControlledTooltip>
        </div>
    );
};
